module.exports = __webpack_public_path__ + "img/icon_benke@2x.da5a5325.png";